import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md',
  showText = true 
}) => {
  // Define size classes
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };

  // Define text size classes
  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className="flex items-center">
      <img
        src="/repairdata.svg.png"
        alt="RepairData Logo"
        className={`${sizeClasses[size]} shadow-md object-contain`}
      />
      {showText && (
        <span className={`ml-3 font-bold text-gray-900 ${textSizeClasses[size]} tracking-wide`}>
          RepairData
        </span>
      )}
    </div>
  );
};

export default Logo;